/** Mirrors the backend CollectionAccountStatusContract (serialized as PascalCase strings). */
export enum CollectionAccountStatus {
  NotConnected = "NotConnected",
  OnboardingIncomplete = "OnboardingIncomplete",
  Active = "Active",
  Restricted = "Restricted",
}
